import React from 'react';

function Hero() {
  return (
    <section id="hero" className="hero">
      <div className="container">
        <h1>Struggling to Move Forward? Let's Find Your Way Forward, Together.</h1>
        <p>Compassionate, confidential counselling service, available in-person and online. Based in Manchester, England.</p>
        <a href="#contact" className="cta-button">Book a Free 15-Minute Consultation</a>
      </div>
    </section>
  );
}

export default Hero;
